import { render } from "./SearchModalComponent.vue?vue&type=template&id=cdee38e2"
import script from "./SearchModalComponent.vue?vue&type=script&lang=js"
export * from "./SearchModalComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__